import Vue from 'vue'
Vue.filter('formattedTimeDate', function (value) {
  var date = Vue.moment(value)
  return date.format('YYYY-MM-DD HH:mm')
})
